import { IPaths } from "../../types/types";

export const paths: IPaths = {
  main: "/m",
  dashboard: "/dashboard", // залишаємо для зворотної сумісності
  subscription: "/subscription",
  settings: "/settings",
  settingsProfile: "/settings/profile",
  settingsAdmin: "/settings/admin",
  settingsIntegrations: "/settings/integrations",
  settingsDeploy: "/settings/deploy",
  settingsTerms: "/settings/terms",
  
  users: "/users",
  roles: "/roles",
  permissions: "/permissions",
  tenantList: "/tenant-list/",
  logs: "/logs",
  reports: "/reports",
  products: "/products",
  categories: "/categories",
  clients: "/clients",
  clientSupport: "/client/:companyId",
  admins: "/clients/:companyId/admins",
  notifications: "/notifications",
  tickets: "/ticket",
  ticketThread: "/ticket/:id",
  feedback: "/feedback",
  feedbackThread: "/feedback/:id",
  ai: "/ai",
};
